import {
  deleteOne,
  getAll,
  getOne,
  migrateLocalStorageIfNeeded,
  putMany,
  putOne,
} from "./db.js";
import { isRemoteAvailable } from "./db.js";
import { canonicalCategoryId } from "./category-merge.js";
import { getPushStatus, initPushServiceWorker, isPushSupported, subscribeToPush } from "./push-client.js";

const CATEGORIES = [
  { id: "Supermercat", icon: "🛒", color: "#2f8f67" },
  { id: "Lloguer", icon: "🏠", color: "#5d55aa" },
  { id: "Subministraments", icon: "💡", color: "#c47d1a" },
  { id: "Restaurants", icon: "🍽️", color: "#c43d5a" },
  { id: "Oci", icon: "🎬", color: "#1a7a9e" },
  { id: "Transport", icon: "🚗", color: "#4a6fa5" },
  { id: "Salut", icon: "🧾", color: "#b53a2c" },
  { id: "Mascotes", icon: "🐾", color: "#8b6914" },
  { id: "Viatges", icon: "✈️", color: "#176b5b" },
  { id: "Altres", icon: "📦", color: "#6f6458" },
];

const CATEGORY_ICON_OPTIONS = [
  "💈",
  "💇",
  "✂️",
  "🎁",
  "📚",
  "🧰",
  "🪴",
  "🏋️",
  "🍼",
  "🎮",
  "☕",
  "🎓",
  "🐶",
  "🧾",
  "🛒",
];

const VIEWS = {
  overview: "Resum",
  movements: "Moviments",
  settlements: "Liquidacions",
  settings: "Ajustos",
};

const USERS = [
  { id: "clara", label: "Clara", password: "1234", partnerIndex: 0 },
  { id: "adri", label: "Adri", password: "1234", partnerIndex: 1 },
];
const SESSION_KEY = "mitjapart-session";
const LEDGER_PREFERENCE_KEY = "mitjapart-ledger-preference";

const state = {
  settings: { partners: ["Persona 1", "Persona 2"], theme: "light" },
  categories: CATEGORIES,
  expenses: [],
  recurring: [],
  settlements: [],
  month: monthKey(new Date()),
  view: "overview",
  navDirection: "",
  filters: { search: "", category: "", payer: "", split: "", type: "" },
  trendOffset: 0,
  breakdownScope: "group",
  editingExpenseId: null,
  ledgerMode: "shared",
  personalOwner: 0,
  currentUserId: null,
};

const els = {
  app: document.querySelector(".app"),
  loading: document.querySelector("#loadingScreen"),
  passwordScreen: document.querySelector("#passwordScreen"),
  passwordForm: document.querySelector("#passwordForm"),
  passwordInput: document.querySelector("#passwordInput"),
  rememberPassword: document.querySelector("#rememberPassword"),
  passwordError: document.querySelector("#passwordError"),
  nav: document.querySelector("#nav"),
  bottomNav: document.querySelector("#bottomNav"),
  partnerNames: document.querySelector("#partnerNames"),
  themeToggle: document.querySelector("#themeToggle"),
  main: document.querySelector(".main"),
  viewTitle: document.querySelector("#viewTitle"),
  monthLabel: document.querySelector("#monthLabel"),
  prevMonth: document.querySelector("#prevMonth"),
  nextMonth: document.querySelector("#nextMonth"),
  todayMonth: document.querySelector("#todayMonth"),
  openExpenseModal: document.querySelector("#openExpenseModal"),
  balanceTitle: document.querySelector("#balanceTitle"),
  balanceHelp: document.querySelector("#balanceHelp"),
  goSettle: document.querySelector("#goSettle"),
  monthTotal: document.querySelector("#monthTotal"),
  monthTotalLabel: document.querySelector("#monthTotalLabel"),
  paidByA: document.querySelector("#paidByA"),
  paidByB: document.querySelector("#paidByB"),
  paidA: document.querySelector("#paidA"),
  paidB: document.querySelector("#paidB"),
  monthCount: document.querySelector("#monthCount"),
  categoryLegend: document.querySelector("#categoryLegend"),
  categoryBreakdown: document.querySelector("#categoryBreakdown"),
  categoryScope: document.querySelector("#categoryScope"),
  trendChart: document.querySelector("#trendChart"),
  trendLegend: document.querySelector("#trendLegend"),
  trendRange: document.querySelector("#trendRange"),
  trendPrev: document.querySelector("#trendPrev"),
  trendNext: document.querySelector("#trendNext"),
  recentList: document.querySelector("#recentList"),
  inlineExpenseForm: document.querySelector("#inlineExpenseForm"),
  searchInput: document.querySelector("#searchInput"),
  categoryFilter: document.querySelector("#categoryFilter"),
  payerFilter: document.querySelector("#payerFilter"),
  typeFilter: document.querySelector("#typeFilter"),
  splitFilter: document.querySelector("#splitFilter"),
  expenseList: document.querySelector("#expenseList"),
  expenseMeta: document.querySelector("#expenseMeta"),
  settingsForm: document.querySelector("#settingsForm"),
  partnerA: document.querySelector("#partnerA"),
  partnerB: document.querySelector("#partnerB"),
  pushStatus: document.querySelector("#pushStatus"),
  enablePush: document.querySelector("#enablePush"),
  pushBanner: document.querySelector("#pushBanner"),
  pushBannerText: document.querySelector("#pushBannerText"),
  pushBannerEnable: document.querySelector("#pushBannerEnable"),
  pushBannerLater: document.querySelector("#pushBannerLater"),
  settlementHint: document.querySelector("#settlementHint"),
  settlementSummary: document.querySelector("#settlementSummary"),
  settlementForm: document.querySelector("#settlementForm"),
  settlementList: document.querySelector("#settlementList"),
  settleBalanceSettings: document.querySelector("#settleBalanceSettings"),
  expenseDialog: document.querySelector("#expenseDialog"),
  dialogTitle: document.querySelector("#dialogTitle"),
  modalExpenseForm: document.querySelector("#modalExpenseForm"),
  modalExpenseFields: document.querySelector("#modalExpenseFields"),
  confirmDialog: document.querySelector("#confirmDialog"),
  confirmTitle: document.querySelector("#confirmTitle"),
  confirmMessage: document.querySelector("#confirmMessage"),
  confirmCancel: document.querySelector("#confirmCancel"),
  confirmSecondary: document.querySelector("#confirmSecondary"),
  confirmAccept: document.querySelector("#confirmAccept"),
  recurringList: document.querySelector("#recurringList"),
  fieldsTemplate: document.querySelector("#expenseFieldsTemplate"),
  emptyTemplate: document.querySelector("#emptyTemplate"),
  toastHost: document.querySelector("#toastHost"),
  ledgerHint: document.querySelector("#ledgerHint"),
  sessionUserLabel: document.querySelector("#sessionUserLabel"),
  logoutButton: document.querySelector("#logoutButton"),
};

init();

async function init() {
  try {
    const migrated = await migrateLocalStorageIfNeeded();
    await loadState();
    restoreLedgerPreference();
    await repairOrphanFixedExpenses();
    await removeDuplicateFixedOneoffs();
    await removePrematureFixedExpenses();
    await generateRecurringForMonth({ notify: false });
    buildStaticForms();
    bindEvents();
    applyTheme();
    render();
    if (isPushSupported()) initPushServiceWorker();
    els.loading.hidden = true;
    await showUnlockedAppIfRemembered();
    if (migrated) toast("Dades antigues migrades a IndexedDB");
  } catch (error) {
    console.error(error);
    els.loading.innerHTML = "<strong>No s'ha pogut obrir la base de dades.</strong>";
  }
}

async function loadState() {
  const [settings, expenses, recurring, settlements] = await Promise.all([
    getOne("settings", "main"),
    getAll("expenses"),
    getAll("recurring"),
    getAll("settlements"),
  ]);

  state.settings = settings || state.settings;
  const visibleExpenses = sanitizePersonalRecords(expenses);
  const visibleRecurring = sanitizePersonalRecords(recurring);
  state.categories = getAllCategories(settings, visibleExpenses, visibleRecurring);
  state.expenses = visibleExpenses.sort(sortByDateDesc);
  state.recurring = visibleRecurring.sort((a, b) => a.day - b.day);
  state.settlements = settlements.sort(sortByDateDesc);
}

function sanitizePersonalRecords(records) {
  // Drop the other person's personal items from the in-memory session.
  // Shared records stay. If no user is logged in yet, keep everything until session starts.
  if (state.currentUserId == null) return Array.isArray(records) ? [...records] : [];
  return (records || []).filter((item) => {
    if (item?.splitType !== "personal") return true;
    return Number(item.payer) === state.personalOwner;
  });
}

function buildStaticForms() {
  buildExpenseForm(els.inlineExpenseForm, { date: today(), submit: "Afegir despesa" });
  buildExpenseForm(els.modalExpenseFields, { date: today() });
  buildSettlementForm();
}

function bindEvents() {
  bindZoomLock();

  els.passwordForm.addEventListener("submit", unlockApp);

  function handleNavClick(event) {
    const button = event.target.closest("[data-view]");
    if (button) setView(button.dataset.view);
  }

  els.nav.addEventListener("click", handleNavClick);
  els.bottomNav.addEventListener("click", handleNavClick);

  document.body.addEventListener("click", (event) => {
    const ledgerTab = event.target.closest("button[data-ledger]");
    if (ledgerTab) {
      setLedgerMode(ledgerTab.dataset.ledger);
      return;
    }
  });

  if (els.logoutButton) {
    els.logoutButton.addEventListener("click", logoutCurrentUser);
  }

  document.body.addEventListener("click", async (event) => {
    const goView = event.target.closest("[data-go-view]");
    if (goView) setView(goView.dataset.goView);

    const openExpense = event.target.closest("[data-open-expense]");
    if (openExpense) openExpenseDialog();

    const close = event.target.closest("[data-close-dialog]");
    if (close) closeExpenseDialog();

    const edit = event.target.closest("[data-edit-expense]");
    if (edit) openExpenseDialog(edit.dataset.editExpense);

    const remove = event.target.closest("[data-delete]");
    if (remove) await deleteRecord(remove.dataset.delete);
  });

  els.prevMonth.addEventListener("click", () => changeMonth(-1));
  els.nextMonth.addEventListener("click", () => changeMonth(1));
  els.todayMonth.addEventListener("click", async () => {
    state.month = monthKey(new Date());
    state.trendOffset = 0;
    await generateRecurringForMonth({ notify: false });
    render();
  });

  els.themeToggle.addEventListener("click", saveTheme);
  els.goSettle.addEventListener("click", () => setView("settlements"));
  els.settleBalanceSettings.addEventListener("click", settleBalance);
  els.trendPrev.addEventListener("click", () => changeTrendWindow(1));
  els.trendNext.addEventListener("click", () => changeTrendWindow(-1));
  els.categoryScope.addEventListener("change", (event) => {
    state.breakdownScope = event.target.value;
    renderBreakdown();
    renderTrend();
  });

  els.inlineExpenseForm.addEventListener("submit", saveExpenseFromForm);
  els.modalExpenseForm.addEventListener("submit", saveExpenseFromForm);
  els.settingsForm.addEventListener("submit", saveSettings);
  els.settlementForm.addEventListener("submit", saveSettlement);
  els.enablePush.addEventListener("click", enablePushNotifications);
  els.pushBannerEnable?.addEventListener("click", enablePushFromBanner);
  els.pushBannerLater?.addEventListener("click", dismissPushBanner);

  els.searchInput.addEventListener("input", (event) => {
    state.filters.search = event.target.value.trim().toLowerCase();
    renderExpenseLists();
  });
  els.categoryFilter.addEventListener("change", (event) => {
    state.filters.category = event.target.value;
    renderExpenseLists();
  });
  els.payerFilter.addEventListener("change", (event) => {
    state.filters.payer = event.target.value;
    renderExpenseLists();
  });
  els.typeFilter.addEventListener("change", (event) => {
    state.filters.type = event.target.value;
    renderExpenseLists();
  });
  els.splitFilter.addEventListener("change", (event) => {
    state.filters.split = event.target.value;
    renderExpenseLists();
  });

  document.addEventListener("keydown", (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "n") {
      event.preventDefault();
      openExpenseDialog();
    }
  });
}

async function unlockApp(event) {
  event.preventDefault();
  els.passwordError.hidden = true;

  const form = new FormData(event.currentTarget);
  const userId = String(form.get("loginUser") || "");
  const password = String(form.get("password") || "");
  const user = USERS.find((item) => item.id === userId);

  if (!user || user.password !== password) {
    els.passwordError.hidden = false;
    els.passwordInput.select();
    return;
  }

  await startSession(user, els.rememberPassword.checked);
}

async function showUnlockedAppIfRemembered() {
  const session = readSession();
  if (session?.userId) {
    const user = USERS.find((item) => item.id === session.userId);
    if (user) {
      await startSession(user, true, { silent: true });
      return;
    }
  }

  els.passwordScreen.hidden = false;
  els.passwordInput.focus();
}

function showApp() {
  els.passwordScreen.hidden = true;
  els.app.hidden = false;
}

function readSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

async function startSession(user, remember, options = {}) {
  state.currentUserId = user.id;
  state.personalOwner = user.partnerIndex;
  if (remember) {
    localStorage.setItem(SESSION_KEY, JSON.stringify({ userId: user.id }));
  } else {
    localStorage.removeItem(SESSION_KEY);
  }
  restoreLedgerPreference();
  // Personal owner is always the logged-in user — never switchable.
  state.personalOwner = user.partnerIndex;
  els.app.classList.add("is-loading");
  showApp();
  try {
    await loadState();
  } finally {
    els.app.classList.remove("is-loading");
  }
  els.app.classList.toggle("is-offline", !isRemoteAvailable());
  if (!options.silent) {
    toast(`Hola, ${displayUserName(user)}`);
  }
  buildStaticForms();
  render();
  // Tag this device's push subscription with the logged-in partner.
  syncPushSubscriptionOwner(user.partnerIndex)
    .catch((error) => console.warn(error))
    .finally(() => renderPushBanner().catch((error) => console.warn(error)));
}

async function syncPushSubscriptionOwner(partnerIndex) {
  if (!isPushSupported() || partnerIndex == null || Number.isNaN(Number(partnerIndex))) return;
  try {
    await subscribeToPush(Number(partnerIndex), { quiet: true });
  } catch (error) {
    // Ignore if permission was never granted on this device.
    if (Notification.permission !== "granted") return;
    console.warn(error);
  }
}

function logoutCurrentUser() {
  localStorage.removeItem(SESSION_KEY);
  state.currentUserId = null;
  state.ledgerMode = "shared";
  els.app.hidden = true;
  els.passwordScreen.hidden = false;
  els.passwordForm.reset();
  els.passwordError.hidden = true;
  els.passwordInput.focus();
  toast("Sessió tancada");
}

function currentUser() {
  return USERS.find((item) => item.id === state.currentUserId) || null;
}

function bindZoomLock() {
  const preventZoom = (event) => event.preventDefault();
  const zoomKeys = new Set(["+", "-", "=", "_", "0"]);

  document.addEventListener("gesturestart", preventZoom, { passive: false });
  document.addEventListener("gesturechange", preventZoom, { passive: false });
  document.addEventListener("gestureend", preventZoom, { passive: false });

  document.addEventListener(
    "wheel",
    (event) => {
      if (event.ctrlKey || event.metaKey) event.preventDefault();
    },
    { passive: false },
  );

  document.addEventListener("keydown", (event) => {
    if ((event.ctrlKey || event.metaKey) && zoomKeys.has(event.key)) {
      event.preventDefault();
    }
  });
}

function render() {
  els.app?.classList.toggle("is-offline", state.currentUserId != null && !isRemoteAvailable());
  renderShell();
  renderSummary();
  renderBreakdown();
  renderTrend();
  renderExpenseLists();
  renderSettings();
  renderSettlements();
}

function renderShell() {
  els.viewTitle.textContent = VIEWS[state.view];
  els.monthLabel.textContent = formatMonth(state.month);
  const user = currentUser();
  els.partnerNames.textContent = user
    ? `${user.label} · ${state.settings.partners.join(" i ")}`
    : state.settings.partners.join(" i ");
  document.querySelectorAll("[data-view]").forEach((button) => {
    button.classList.toggle(
      "is-active",
      button.dataset.view === state.view && (button.classList.contains("nav-link") || button.classList.contains("bottom-link")),
    );
  });
  document.querySelectorAll(".view").forEach((view) => {
    view.classList.toggle("is-active", view.dataset.view === state.view);
  });
  if (state.navDirection) els.main?.setAttribute("data-nav", state.navDirection);
  els.themeToggle.textContent = state.settings.theme === "dark" ? "☀" : "☾";
  els.themeToggle.setAttribute(
    "aria-label",
    state.settings.theme === "dark" ? "Activar mode clar" : "Activar mode fosc",
  );
  renderLedgerControls();
}

function renderSummary() {
  const monthExpenses = visibleExpensesInMonth(state.month);
  const paid = [0, 0];
  let total = 0;

  monthExpenses.forEach((expense) => {
    paid[expense.payer] += expense.amount;
    total += expense.amount;
  });

  setCount(els.monthTotal, "monthTotal", total);
  setCount(els.monthCount, "monthCount", monthExpenses.length, (value) => String(Math.round(value)));
  if (els.monthTotalLabel) {
    els.monthTotalLabel.textContent =
      state.ledgerMode === "personal"
        ? `Total de ${state.settings.partners[state.personalOwner]}`
        : "Total del mes";
  }
  if (state.ledgerMode === "shared") {
    els.paidByA.textContent = `Pagat per ${state.settings.partners[0]}`;
    els.paidByB.textContent = `Pagat per ${state.settings.partners[1]}`;
    setCount(els.paidA, "paidA", paid[0]);
    setCount(els.paidB, "paidB", paid[1]);
  }

  if (state.ledgerMode === "personal") {
    return;
  }

  const balance = calculateBalance();
  if (Math.abs(balance) < 0.01) {
    els.balanceTitle.textContent = "Tot quadrat";
    els.balanceHelp.textContent = "Ara mateix ningu deu diners a l'altre.";
    els.settlementHint.textContent = "No hi ha cap liquidacio pendent.";
    els.settleBalanceSettings.disabled = true;
    els.goSettle.disabled = true;
    const amount = els.settlementForm.querySelector('[name="amount"]');
    if (amount) amount.value = "";
    return;
  }

  const debtor = balance > 0 ? 1 : 0;
  const creditor = balance > 0 ? 0 : 1;
  els.balanceTitle.innerHTML = `${escapeHtml(state.settings.partners[debtor])} deu <span class="hero-amount"></span>`;
  setCount(els.balanceTitle.querySelector(".hero-amount"), "balanceAmount", Math.abs(balance));
  els.balanceHelp.textContent = `A ${state.settings.partners[creditor]} per equilibrar les despeses compartides.`;
  els.settlementHint.textContent = `${state.settings.partners[debtor]} pot pagar ${money(Math.abs(balance))} a ${state.settings.partners[creditor]}.`;
  els.settleBalanceSettings.disabled = false;
  els.goSettle.disabled = false;
  suggestSettlementForm();
}

function renderBreakdown() {
  renderBreakdownScopeControls();
  const rows = totalsByCategory(state.month, state.breakdownScope);
  const showPayerSplit = state.breakdownScope === "group";
  els.categoryLegend.innerHTML = showPayerSplit
    ? [0, 1]
        .map((payer) => `<span><i style="background:${payerTrendColor(payer)}"></i>${escapeHtml(state.settings.partners[payer])}</span>`)
        .join("")
    : "";
  if (!rows.length) {
    renderEmpty(els.categoryBreakdown);
    return;
  }

  const max = Math.max(...rows.map((row) => row.total), 1);
  els.categoryBreakdown.innerHTML = rows
    .map((row) => {
      const percent = Math.min((row.total / max) * 100, 100);
      return `
        <div class="break-row">
          <div>
            <strong><span class="category-badge" style="background:${categoryMeta(row.category).color}">${categoryMeta(row.category).icon}</span>${escapeHtml(row.category)}</strong>
            <span>${money(row.total)}</span>
          </div>
          <div class="progress">
            ${
              showPayerSplit
                ? `<span class="progress-stack" style="width:${percent}%">
                    ${row.payers
                      .map((amount, payer) => {
                        const width = row.total ? (amount / row.total) * 100 : 0;
                        return amount
                          ? `<i class="progress-segment" style="width:${width}%;background:${payerTrendColor(payer)}" title="${escapeHtml(state.settings.partners[payer])} ${money(amount)}"></i>`
                          : "";
                      })
                      .join("")}
                  </span>`
                : `<span style="width:${percent}%;background:${categoryMeta(row.category).color}"></span>`
            }
          </div>
        </div>
      `;
    })
    .join("");
  animateProgress(els.categoryBreakdown);
}

function renderBreakdownScopeControls() {
  els.categoryScope.innerHTML = `
    <option value="group">Grup</option>
    <option value="0">${escapeHtml(state.settings.partners[0])}</option>
    <option value="1">${escapeHtml(state.settings.partners[1])}</option>
  `;
  els.categoryScope.value = state.breakdownScope;
}

function renderTrend() {
  const months = trendMonths(6);
  const categories = topTrendCategories(months, state.breakdownScope);
  const totals = months.map((month) => sum(totalsByCategory(month, state.breakdownScope).map((row) => row.total)));
  const max = Math.max(...totals, 1);

  els.trendRange.textContent = `${shortMonth(months[0])} - ${shortMonth(months.at(-1))}`;
  els.trendNext.disabled = state.trendOffset === 0;

  els.trendChart.innerHTML = months
    .map((month, index) => {
      const totalHeight = Math.max((totals[index] / max) * 140, 4);
      const monthTotals = totalsByCategory(month, state.breakdownScope);
      return `
        <div class="bar-wrap">
          <span>${money(totals[index])}</span>
          <div class="stacked-bar" style="height:${totalHeight}px">
            ${categories
              .map((category) => {
                const amount = monthTotals.find((row) => row.category === category)?.total || 0;
                const height = totals[index] ? (amount / totals[index]) * 100 : 0;
                return amount
                  ? `<i style="height:${height}%;background:${categoryMeta(category).color}" title="${escapeHtml(category)} ${money(amount)}"></i>`
                  : "";
              })
              .join("")}
          </div>
          <small>${shortMonth(month)}</small>
        </div>
      `;
    })
    .join("");

  els.trendLegend.innerHTML = categories
    .map((category) => {
      const meta = categoryMeta(category);
      return `<span><i style="background:${meta.color}"></i>${meta.icon} ${escapeHtml(category)}</span>`;
    })
    .join("");
}

function renderExpenseLists() {
  const monthExpenses = visibleExpensesInMonth(state.month);
  const filtered = filterExpenses(monthExpenses);

  renderExpenseCollection(els.recentList, monthExpenses.slice(0, 5));
  renderExpenseCollection(els.expenseList, filtered);
  els.expenseMeta.textContent = filtered.length
    ? `${filtered.length} moviment(s), ${money(sum(filtered.map((expense) => expense.amount)))}`
    : "";

  renderFilterOptions();
}

function renderExpenseCollection(container, expenses) {
  if (!expenses.length) {
    renderEmpty(container);
    return;
  }

  const groups = expenses.reduce((acc, expense) => {
    const key = expense.date;
    if (!acc.has(key)) acc.set(key, []);
    acc.get(key).push(expense);
    return acc;
  }, new Map());

  container.innerHTML = [...groups.entries()]
    .map(([date, items]) => {
      const total = sum(items.map((expense) => expense.amount));
      return `
        <section class="expense-day">
          <div class="expense-day-head">
            <strong>${formatDate(date)}</strong>
            <span>${items.length} moviment(s) · ${money(total)}</span>
          </div>
          ${items.map(expenseHtml).join("")}
        </section>
      `;
    })
    .join("");
}

function expenseHtml(expense) {
  const fixed = expense.recurringId || expense.expenseKind === "fixed";
  const meta = categoryMeta(expense.category);
  const payerName = state.settings.partners[expense.payer] || "";
  return `
    <article class="expense-card">
      <div class="expense-main">
        <div class="avatar" style="background:${partnerAvatarColor(expense.payer)}" aria-hidden="true">${initials(payerName)}</div>
        <div class="expense-copy">
          <strong>${escapeHtml(expense.description)}</strong>
          <span><span class="category-badge" style="background:${meta.color}">${meta.icon}</span>${escapeHtml(expense.category)} · ${escapeHtml(payerName)}</span>
        </div>
      </div>
      <div class="item-side">
        <strong>${money(expense.amount)}</strong>
        <span class="chevron" aria-hidden="true"></span>
      </div>
      <div class="expense-tags">
        <span class="pill mini${fixed ? " pending" : ""}">${fixed ? "Fixa" : "Puntual"}</span>
        <span class="pill mini">${splitLabel(expense)}</span>
      </div>
      ${expense.notes ? `<p>${escapeHtml(expense.notes)}</p>` : ""}
      <div class="row-actions">
        <button class="subtle-button small" type="button" data-edit-expense="${expense.id}">Editar</button>
        <button class="danger-link small" type="button" data-delete="expenses:${expense.id}">Eliminar</button>
      </div>
    </article>
  `;
}

function renderSettings() {
  els.partnerA.value = state.settings.partners[0];
  els.partnerB.value = state.settings.partners[1];
  renderRecurring();
  renderPushSettings();
}

function renderRecurring() {
  if (!els.recurringList) return;
  if (!state.recurring.length) {
    els.recurringList.innerHTML = `
      <div class="empty">
        <strong>Cap despesa fixa activa</strong>
        <span>Marca «Fixa mensual» quan afegeixis una despesa per crear-ne una.</span>
      </div>
    `;
    return;
  }

  els.recurringList.innerHTML = state.recurring
    .map((item) => {
      const alreadyGenerated = state.expenses.some(
        (expense) => expense.recurringId === item.id && expense.date.startsWith(state.month),
      );
      const skipped = (item.skippedMonths || []).includes(state.month);

      const payerName = state.settings.partners[item.payer] || "";
      const status = skipped
        ? { label: "Omesa", className: "pill mini" }
        : alreadyGenerated
          ? { label: "Generada", className: "pill mini success" }
          : { label: "Pendent", className: "pill mini pending" };
      return `
        <article class="list-item">
          <div class="expense-main">
            <div class="avatar" style="background:${partnerAvatarColor(item.payer)}" aria-hidden="true">${initials(payerName)}</div>
            <div>
              <strong>${escapeHtml(item.description)}</strong>
              <span>Dia ${item.day} · ${escapeHtml(item.category)} · ${escapeHtml(payerName)}</span>
            </div>
          </div>
          <div class="item-side">
            <strong>${money(item.amount)}</strong>
            <span class="chevron" aria-hidden="true"></span>
          </div>
          <div class="expense-tags">
            <span class="${status.className}">${status.label}</span>
          </div>
          <div class="row-actions">
            <button class="danger-link small" type="button" data-delete="recurring:${item.id}">Cancel·lar sèrie</button>
          </div>
        </article>
      `;
    })
    .join("");
}

async function renderPushSettings() {
  if (!els.pushStatus || !els.enablePush) return;

  const status = await getPushStatus();

  if (!status.supported) {
    els.pushStatus.textContent = "Aquest navegador no suporta notificacions push.";
    els.enablePush.hidden = true;
    return;
  }

  if (!status.configured) {
    if (status.configError === "missing-vapid") {
      els.pushStatus.textContent =
        "Falten les claus VAPID al servidor. Afegeix-les a .env.local (local) o a Vercel (producció).";
    } else if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
      els.pushStatus.textContent =
        "En local cal un fitxer .env.local amb DATABASE_URL i les claus VAPID. Reinicia npm run dev després d'afegir-les.";
    } else {
      els.pushStatus.textContent = "Les notificacions encara no estan configurades al servidor.";
    }
    els.enablePush.hidden = true;
    return;
  }

  if (status.enabled) {
    els.pushStatus.textContent = "Notificacions activades en aquest dispositiu.";
    els.enablePush.textContent = "Notificacions activades";
    els.enablePush.disabled = true;
    els.enablePush.hidden = false;
    return;
  }

  if (status.permission === "denied") {
    els.pushStatus.textContent =
      "Has bloquejat les notificacions. Cal activar-les des de la configuració del navegador o del dispositiu.";
    els.enablePush.hidden = true;
    return;
  }

  els.pushStatus.textContent =
    "Rep avisos de despeses de parella. Les particulars només arriben a qui les crea (activa-les amb la teva sessió).";
  els.enablePush.textContent = "Activar notificacions";
  els.enablePush.disabled = false;
  els.enablePush.hidden = false;
}

async function enablePushNotifications() {
  els.enablePush.disabled = true;
  try {
    await subscribeToPush(state.personalOwner);
    toast("Notificacions activades");
  } catch (error) {
    console.error(error);
    toast(error.message || "No s'han pogut activar", "error");
  }
  await renderPushSettings();
  await renderPushBanner();
}

const PUSH_BANNER_KEY = "mitjapart.pushBannerDismissedUntil";
const PUSH_BANNER_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

function pushBannerSnoozed() {
  const until = Number(localStorage.getItem(PUSH_BANNER_KEY) || 0);
  return until > Date.now();
}

function dismissPushBanner() {
  localStorage.setItem(PUSH_BANNER_KEY, String(Date.now() + PUSH_BANNER_SNOOZE_MS));
  if (els.pushBanner) els.pushBanner.hidden = true;
}

async function renderPushBanner() {
  const banner = els.pushBanner;
  if (!banner) return;
  if (state.currentUserId == null || pushBannerSnoozed()) {
    banner.hidden = true;
    return;
  }
  let status;
  try {
    status = await getPushStatus();
  } catch {
    banner.hidden = true;
    return;
  }
  const standalone = window.navigator.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches;
  if (!status.supported) {
    els.pushBannerText.textContent = standalone
      ? "Aquest dispositiu no permet notificacions push."
      : "Per rebre notificacions, primer afegeix MitjaPart a la pantalla d'inici: botó Compartir › Afegir a la pantalla d'inici.";
    els.pushBannerEnable.hidden = true;
    els.pushBannerLater.textContent = "Tancar";
    banner.hidden = false;
    return;
  }
  if (status.enabled || (status.permission === "granted" && status.subscribed) || !status.configured) {
    banner.hidden = true;
    return;
  }
  if (status.permission === "denied") {
    els.pushBannerText.textContent =
      "Les notificacions estan bloquejades. Activa-les a Ajustos de l'iPhone › Notificacions › MitjaPart.";
    els.pushBannerEnable.hidden = true;
    els.pushBannerLater.textContent = "Tancar";
  } else {
    els.pushBannerText.textContent = "Activa les notificacions per saber quan l'altra persona afegeix una despesa";
    els.pushBannerEnable.hidden = false;
    els.pushBannerEnable.disabled = false;
    els.pushBannerLater.textContent = "Ara no";
  }
  banner.hidden = false;
}

async function enablePushFromBanner() {
  els.pushBannerEnable.disabled = true;
  await enablePushNotifications();
}

function renderBudgets() {
  const entries = Object.entries(state.budgets);
  if (!entries.length) {
    renderEmpty(els.budgetList);
    return;
  }

  els.budgetList.innerHTML = entries
    .map(
      ([category, amount]) => `
        <article class="mini-item">
          <span>${escapeHtml(category)}</span>
          <strong>${money(amount)}</strong>
          <button class="danger-link small" type="button" data-delete="budgets:${category}">Eliminar</button>
        </article>
      `,
    )
    .join("");
}

function renderSettlements() {
  const balance = calculateBalance();
  const paidBack = sum(state.settlements.map((settlement) => settlement.amount));
  const next =
    Math.abs(balance) < 0.01
      ? "Tot igualat"
      : `${state.settings.partners[balance > 0 ? 1 : 0]} → ${state.settings.partners[balance > 0 ? 0 : 1]}`;
  els.settlementSummary.innerHTML = `
    <article><span>Proper moviment</span><strong>${escapeHtml(next)}</strong></article>
    <article><span>Import pendent</span><strong data-count-key="settlementPending"></strong></article>
    <article><span>Ja liquidat</span><strong data-count-key="settlementPaid"></strong></article>
  `;
  setCount(els.settlementSummary.querySelector('[data-count-key="settlementPending"]'), "settlementPending", Math.abs(balance));
  setCount(els.settlementSummary.querySelector('[data-count-key="settlementPaid"]'), "settlementPaid", paidBack);

  if (!state.settlements.length) {
    renderEmpty(els.settlementList);
    return;
  }

  els.settlementList.innerHTML = state.settlements
    .slice(0, 10)
    .map(
      (settlement) => {
        const fromName = state.settings.partners[settlement.from] || "";
        const toName = state.settings.partners[settlement.to] || "";
        return `
        <article class="mini-item">
          <div class="avatar" style="background:${partnerAvatarColor(settlement.from)}" aria-hidden="true">${initials(fromName)}</div>
          <span>${formatDate(settlement.date)} · ${escapeHtml(fromName)} → ${escapeHtml(toName)}${settlement.note ? ` · ${escapeHtml(settlement.note)}` : ""}</span>
          <strong>${money(settlement.amount)}</strong>
          <span class="chevron" aria-hidden="true"></span>
          <button class="danger-link small" type="button" data-delete="settlements:${settlement.id}">Eliminar</button>
        </article>
      `;
      },
    )
    .join("");
}

function buildExpenseForm(container, options = {}) {
  container.innerHTML = "";
  container.append(els.fieldsTemplate.content.cloneNode(true));
  fillSelects(container);
  container.querySelector('[name="date"]').value = options.date || today();
  if (options.submit) {
    const button = document.createElement("button");
    button.className = "primary-button";
    button.type = "submit";
    button.textContent = options.submit;
    container.append(button);
  }
  bindSplitPicker(container);
  bindCategoryCreator(container);
  applyLedgerToExpenseForm(container);
}

function buildRecurringForm() {
  els.recurringForm.innerHTML = `
    <label>Concepte <input name="description" required placeholder="Lloguer, internet..." /></label>
    <div class="form-grid">
      <label>Import <input name="amount" type="number" min="0.01" step="0.01" required /></label>
      <label>Dia <input name="day" type="number" min="1" max="28" value="1" required /></label>
    </div>
    <div class="form-grid">
      <label>Qui paga <select name="payer" data-partners></select></label>
      <label>Categoria <select name="category" data-categories></select></label>
    </div>
    <label data-new-category hidden>Nova categoria <input name="newCategory" placeholder="Ex: Comunitat, escola..." /></label>
    <div class="split-picker">
      <label><input type="radio" name="splitType" value="equal" checked /> 50/50</label>
      <label><input type="radio" name="splitType" value="custom" /> Percentatge</label>
      <label><input type="radio" name="splitType" value="personal" /> Personal</label>
    </div>
    <label data-share-field hidden>% persona 1 <input name="shareA" type="number" min="0" max="100" value="50" /></label>
    <button class="primary-button" type="submit">Guardar fixa</button>
  `;
  fillSelects(els.recurringForm);
  bindSplitPicker(els.recurringForm);
  bindCategoryCreator(els.recurringForm);
}

function buildSettlementForm() {
  els.settlementForm.innerHTML = `
    <div class="form-grid">
      <label>Qui paga <select name="from" data-partners></select></label>
      <label>Qui rep <select name="to" data-partners></select></label>
    </div>
    <div class="form-grid">
      <label>Import <input name="amount" type="number" min="0.01" step="0.01" required /></label>
      <label>Data <input name="date" type="date" required /></label>
    </div>
    <label>Nota <input name="note" placeholder="Transferencia, Bizum..." /></label>
    <button class="secondary-button" type="submit">Registrar liquidacio</button>
  `;
  fillSelects(els.settlementForm);
  {
    const fromSel = els.settlementForm.querySelector('[name="from"]');
    const toSel = els.settlementForm.querySelector('[name="to"]');
    if (fromSel && toSel) {
      if (state.personalOwner != null) fromSel.value = String(state.personalOwner);
      toSel.value = fromSel.value === "0" ? "1" : "0";
      fromSel.addEventListener("change", () => {
        if (toSel.value === fromSel.value) toSel.value = fromSel.value === "0" ? "1" : "0";
      });
    }
  }
  els.settlementForm.querySelector('[name="date"]').value = today();
  suggestSettlementForm();
}

function suggestSettlementForm() {
  const balance = calculateBalance();
  const from = els.settlementForm.querySelector('[name="from"]');
  const to = els.settlementForm.querySelector('[name="to"]');
  const amount = els.settlementForm.querySelector('[name="amount"]');
  if (!from || !to || !amount || Math.abs(balance) < 0.01) return;
  const debtor = balance > 0 ? 1 : 0;
  const creditor = balance > 0 ? 0 : 1;
  from.value = String(debtor);
  to.value = String(creditor);
  amount.value = String(round2(Math.abs(balance)));
}

function fillSelects(root) {
  root.querySelectorAll("[data-partners]").forEach((select) => {
    const current = select.value;
    select.innerHTML = state.settings.partners
      .map((name, index) => `<option value="${index}">${escapeHtml(name)}</option>`)
      .join("");
    select.value = current || "0";
  });

  root.querySelectorAll("[data-categories]").forEach((select) => {
    const current = select.value;
    select.innerHTML =
      state.categories
        .map(
          (category) =>
            `<option value="${escapeHtml(category.id)}">${category.icon} ${escapeHtml(category.id)}</option>`,
        )
        .join("") + '<option value="__new__">+ Crear categoria...</option>';
    select.value = current && [...select.options].some((option) => option.value === current)
      ? current
      : state.categories[0].id;
  });
}

function renderFilterOptions() {
  const category = els.categoryFilter.value;
  const payer = els.payerFilter.value;
  els.categoryFilter.innerHTML =
    '<option value="">Totes les categories</option>' +
    state.categories
      .map((item) => `<option value="${escapeHtml(item.id)}">${item.icon} ${escapeHtml(item.id)}</option>`)
      .join("");
  els.payerFilter.innerHTML =
    '<option value="">Tots els pagadors</option>' +
    state.settings.partners
      .map((name, index) => `<option value="${index}">${escapeHtml(name)}</option>`)
      .join("");
  els.categoryFilter.value = category;
  els.payerFilter.value = payer;
}

function bindCategoryCreator(root) {
  const select = root.querySelector("[data-categories]");
  const newCategory = root.querySelector("[data-new-category]");
  if (!select || !newCategory) return;
  bindIconPicker(root);
  const update = () => {
    newCategory.hidden = select.value !== "__new__";
    if (!newCategory.hidden) {
      const nameInput = newCategory.querySelector('input[name="newCategory"]');
      nameInput?.focus();
    }
  };
  select.addEventListener("change", update);
  update();
}

function bindIconPicker(root) {
  const picker = root.querySelector("[data-icon-picker]");
  const valueInput = root.querySelector("[data-icon-value]");
  if (!picker || !valueInput || picker.dataset.ready === "1") return;
  picker.dataset.ready = "1";
  const selected = valueInput.value || CATEGORY_ICON_OPTIONS[0];
  valueInput.value = selected;
  picker.replaceChildren();
  for (const icon of CATEGORY_ICON_OPTIONS) {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("role", "option");
    button.setAttribute("aria-label", `Logo ${icon}`);
    button.setAttribute("aria-selected", icon === selected ? "true" : "false");
    button.dataset.icon = icon;
    button.textContent = icon;
    if (icon === selected) button.classList.add("is-selected");
    picker.append(button);
  }
  picker.addEventListener("click", (event) => {
    const button = event.target.closest("button[data-icon]");
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    valueInput.value = button.dataset.icon || button.textContent || CATEGORY_ICON_OPTIONS[0];
    picker.querySelectorAll("button[data-icon]").forEach((item) => {
      const active = item === button;
      item.classList.toggle("is-selected", active);
      item.setAttribute("aria-selected", active ? "true" : "false");
    });
  });
}

function bindSplitPicker(root) {
  const picker = root.querySelector(".split-picker");
  const shareField = root.querySelector("[data-share-field]");
  if (!picker || !shareField) return;
  const update = () => {
    shareField.hidden = root.querySelector('[name="splitType"]:checked')?.value !== "custom";
  };
  picker.addEventListener("change", update);
  update();
}

async function saveExpenseFromForm(event) {
  event.preventDefault();
  const form = event.currentTarget;
  const formData = new FormData(form);
  const category = resolveCategory(formData);
  const data = parseExpenseForm(formData);
  data.category = category.id;
  const existing = state.expenses.find((expense) => expense.id === data.id);
  const wasEditing = Boolean(existing);

  await ensureCategory(category);

  if (wasEditing) {
    if (data.expenseKind === "fixed") {
      // Keep the series link (or repair orphans from older saves that dropped it).
      data.recurringId = existing.recurringId || uid();
      const previous = state.recurring.find((item) => item.id === data.recurringId);
      await putOne("recurring", recurringFromExpense(data, previous));
    } else if (existing.recurringId) {
      // Switched to one-off: stop generating this series in future months.
      await cancelRecurringSeries(existing.recurringId);
    }
  } else if (data.expenseKind === "fixed") {
    data.recurringId = uid();
    await putOne("recurring", recurringFromExpense(data));
  }

  await putOne("expenses", data);

  await loadState();
  form.reset();
  buildExpenseForm(els.inlineExpenseForm, { date: today(), submit: "Afegir despesa" });
  closeExpenseDialog();
  toast(wasEditing ? "Despesa actualitzada" : data.expenseKind === "fixed" ? "Despesa fixa creada" : "Despesa guardada");
  state.editingExpenseId = null;
  render();
}

function recurringFromExpense(data, previous = null) {
  return {
    id: data.recurringId,
    description: data.description,
    amount: data.amount,
    day: dayFromDate(data.date),
    payer: data.payer,
    category: data.category,
    splitType: data.splitType,
    shareA: data.shareA,
    skippedMonths: Array.isArray(previous?.skippedMonths) ? [...previous.skippedMonths] : [],
  };
}

function dayFromDate(date) {
  return clamp(Number(String(date || "").slice(-2)) || 1, 1, 28);
}

/** Delete recurring template and any already-created future month instances. Keeps past/current history. */
async function cancelRecurringSeries(recurringId, { deleteExpenseId = null } = {}) {
  const currentMonth = monthKey(new Date());
  const futureIds = state.expenses
    .filter(
      (expense) =>
        expense.recurringId === recurringId &&
        String(expense.date || "").slice(0, 7) > currentMonth &&
        expense.id !== deleteExpenseId,
    )
    .map((expense) => expense.id);

  await deleteOne("recurring", recurringId);
  for (const id of futureIds) {
    await deleteOne("expenses", id);
  }
  if (deleteExpenseId) {
    await deleteOne("expenses", deleteExpenseId);
  }
}

/** Relink fixed expenses that lost recurringId after an edit (legacy bug). Never deletes rows. */
async function repairOrphanFixedExpenses() {
  const updates = [];

  for (const expense of state.expenses) {
    if (expense.recurringId) continue;
    const looksFixed =
      expense.expenseKind === "fixed" || String(expense.notes || "").includes("Generada autom");
    if (!looksFixed) continue;

    const day = dayFromDate(expense.date);
    const match = state.recurring.find(
      (item) =>
        item.description === expense.description &&
        Number(item.amount) === Number(expense.amount) &&
        Number(item.day) === day &&
        Number(item.payer) === Number(expense.payer) &&
        item.category === expense.category,
    );
    if (!match) continue;

    const month = String(expense.date || "").slice(0, 7);
    const alreadyLinked = state.expenses.some(
      (entry) =>
        entry.id !== expense.id &&
        entry.recurringId === match.id &&
        String(entry.date || "").startsWith(month),
    );
    // If this month already has the linked series entry, leave the orphan for manual cleanup.
    if (alreadyLinked) continue;

    updates.push({ ...expense, recurringId: match.id, expenseKind: "fixed" });
  }

  if (!updates.length) return;
  await putMany("expenses", updates);
  await loadState();
}

/**
 * Remove one-off copies that duplicate an already generated fixed expense
 * in the same month (same description + amount). Keeps the linked fixed row.
 */
async function removeDuplicateFixedOneoffs() {
  const toDelete = [];
  for (const expense of state.expenses) {
    if (expense.recurringId) continue;
    const month = String(expense.date || "").slice(0, 7);
    if (!month) continue;
    const hasFixedTwin = state.expenses.some(
      (entry) =>
        entry.id !== expense.id &&
        entry.recurringId &&
        String(entry.date || "").startsWith(month) &&
        entry.description === expense.description &&
        Number(entry.amount) === Number(expense.amount),
    );
    if (hasFixedTwin) toDelete.push(expense.id);
  }
  if (!toDelete.length) return;
  for (const id of toDelete) {
    await deleteOne("expenses", id);
  }
  await loadState();
}

/**
 * Drop auto-generated fixed expenses created early for future months.
 * Manual future-dated entries are kept. Auto ones regenerate when the month arrives.
 */
async function removePrematureFixedExpenses() {
  const currentMonth = monthKey(new Date());
  const toDelete = state.expenses
    .filter((expense) => {
      if (!expense.recurringId) return false;
      const month = String(expense.date || "").slice(0, 7);
      if (!month || month <= currentMonth) return false;
      return String(expense.notes || "").includes("Generada autom");
    })
    .map((expense) => expense.id);

  if (!toDelete.length) return;
  for (const id of toDelete) {
    await deleteOne("expenses", id);
  }
  await loadState();
}

function parseExpenseForm(form) {
  const id = form.get("id") || uid();
  let splitType = form.get("splitType") || "equal";
  let payer = Number(form.get("payer"));
  const expenseKind = form.get("expenseKind") || "oneoff";
  const category = resolveCategory(form);

  // Keep ledgers strict so personal and shared data never mix by accident.
  if (state.ledgerMode === "personal") {
    splitType = "personal";
    payer = state.personalOwner;
  } else if (splitType === "personal") {
    splitType = "equal";
  }

  return {
    id,
    description: String(form.get("description")).trim(),
    amount: Number(form.get("amount")),
    date: form.get("date"),
    payer,
    category: category.id,
    splitType,
    shareA: splitType === "custom" ? clamp(Number(form.get("shareA")), 0, 100) : 50,
    expenseKind,
    notes: String(form.get("notes") || "").trim(),
  };
}

async function saveRecurring(event) {
  event.preventDefault();
  const form = new FormData(event.currentTarget);
  const splitType = form.get("splitType") || "equal";
  const category = resolveCategory(form);
  await ensureCategory(category);
  await putOne("recurring", {
    id: uid(),
    description: String(form.get("description")).trim(),
    amount: Number(form.get("amount")),
    day: clamp(Number(form.get("day")) || 1, 1, 28),
    payer: Number(form.get("payer")),
    category: category.id,
    splitType,
    shareA: splitType === "custom" ? clamp(Number(form.get("shareA")), 0, 100) : 50,
  });
  await loadState();
  event.currentTarget.reset();
  buildRecurringForm();
  toast("Despesa fixa guardada");
  render();
}

async function saveSettings(event) {
  event.preventDefault();
  await putOne("settings", {
    ...state.settings,
    id: "main",
    partners: [els.partnerA.value.trim(), els.partnerB.value.trim()],
  });
  await loadState();
  fillSelects(document);
  toast("Noms guardats");
  render();
}

async function saveSettlement(event) {
  event.preventDefault();
  const form = new FormData(event.currentTarget);
  const from = Number(form.get("from"));
  const to = Number(form.get("to"));
  if (from === to) {
    toast("Tria dues persones diferents", "error");
    return;
  }
  if (!confirm("Confirmes que vols registrar aquesta liquidacio?")) return;
  await putOne("settlements", {
    id: uid(),
    from,
    to,
    amount: Number(form.get("amount")),
    date: form.get("date"),
    note: String(form.get("note") || "").trim(),
  });
  await loadState();
  event.currentTarget.reset();
  buildSettlementForm();
  toast("Liquidacio registrada");
  render();
}

async function deleteRecord(value) {
  const [store, id] = value.split(":");
  if (store === "expenses") {
    const expense = state.expenses.find((item) => item.id === id);
    if (!canAccessExpense(expense)) {
      toast("No pots eliminar aquesta despesa");
      return;
    }
    if (expense?.recurringId) {
      await deleteFixedExpenseInstance(expense);
      return;
    }
  }
  if (store === "recurring") {
    const item = state.recurring.find((entry) => entry.id === id);
    if (item && isPersonalExpense(item) && Number(item.payer) !== state.personalOwner) {
      toast("No pots eliminar aquesta despesa fixa");
      return;
    }
    const confirmed = await confirmAction({
      title: "Cancel·lar sèrie fixa",
      message:
        "S'aturarà la generació dels propers mesos. Les despeses ja creades a l'historial es conservaran; les del futur encara no vençudes s'eliminaran.",
      acceptLabel: "Cancel·lar sèrie",
    });
    if (!confirmed) return;
    await cancelRecurringSeries(id);
    await loadState();
    toast("Sèrie fixa cancel·lada");
    render();
    return;
  }
  const labels = {
    expenses: "aquesta despesa",
    recurring: "aquesta despesa fixa",
    settlements: "aquesta liquidacio",
  };
  const confirmed = await confirmAction({
    title: "Eliminar registre",
    message: `Segur que vols eliminar ${labels[store] || "aquest registre"}? Aquesta accio no es pot desfer.`,
    acceptLabel: "Eliminar",
  });
  if (!confirmed) return;
  await deleteOne(store, id);
  await loadState();
  toast("Registre eliminat");
  render();
}

async function deleteFixedExpenseInstance(expense) {
  const choice = await confirmAction({
    title: "Despesa fixa",
    message:
      `"${expense.description}" és una despesa fixa mensual. Què vols fer? L'historial d'altres mesos no s'esborra.`,
    acceptLabel: "Només aquest mes",
    secondaryLabel: "Cancel·lar tota la sèrie",
  });
  if (!choice) return;

  if (choice === "secondary") {
    await cancelRecurringSeries(expense.recurringId, { deleteExpenseId: expense.id });
    await loadState();
    toast("Sèrie fixa cancel·lada");
    render();
    return;
  }

  const template = state.recurring.find((item) => item.id === expense.recurringId);
  if (template) {
    const month = String(expense.date || "").slice(0, 7);
    const skipped = new Set(template.skippedMonths || []);
    skipped.add(month);
    await putOne("recurring", { ...template, skippedMonths: [...skipped].sort() });
  }
  await deleteOne("expenses", expense.id);
  await loadState();
  toast("Despesa d'aquest mes eliminada");
  render();
}

function confirmAction({ title, message, acceptLabel = "Confirmar", secondaryLabel = null }) {
  return new Promise((resolve) => {
    els.confirmTitle.textContent = title;
    els.confirmMessage.textContent = message;
    els.confirmAccept.textContent = acceptLabel;
    if (els.confirmSecondary) {
      if (secondaryLabel) {
        els.confirmSecondary.hidden = false;
        els.confirmSecondary.textContent = secondaryLabel;
      } else {
        els.confirmSecondary.hidden = true;
        els.confirmSecondary.textContent = "";
      }
    }

    const finish = (result) => {
      cleanup();
      if (els.confirmDialog.open) els.confirmDialog.close();
      resolve(result);
    };

    const onCancel = () => finish(false);
    const onAccept = () => finish(true);
    const onSecondary = () => finish("secondary");
    const onDialogCancel = (event) => {
      event.preventDefault();
      finish(false);
    };
    const onClose = () => finish(false);
    const cleanup = () => {
      els.confirmCancel.removeEventListener("click", onCancel);
      els.confirmAccept.removeEventListener("click", onAccept);
      els.confirmSecondary?.removeEventListener("click", onSecondary);
      els.confirmDialog.removeEventListener("cancel", onDialogCancel);
      els.confirmDialog.removeEventListener("close", onClose);
      if (els.confirmSecondary) els.confirmSecondary.hidden = true;
    };

    els.confirmCancel.addEventListener("click", onCancel, { once: true });
    els.confirmAccept.addEventListener("click", onAccept, { once: true });
    if (secondaryLabel && els.confirmSecondary) {
      els.confirmSecondary.addEventListener("click", onSecondary, { once: true });
    }
    els.confirmDialog.addEventListener("cancel", onDialogCancel, { once: true });
    els.confirmDialog.addEventListener("close", onClose, { once: true });
    els.confirmDialog.showModal();
  });
}

async function generateRecurringForMonth({ notify = true } = {}) {
  // Only materialize the current calendar month. Past/future browsing must not invent rows.
  const currentMonth = monthKey(new Date());
  if (state.month !== currentMonth) {
    if (notify) {
      toast(state.month < currentMonth ? "Les fixes no es generen en mesos passats" : "Les fixes del futur es crearan quan arribi el mes");
      render();
    }
    return;
  }

  const created = [];
  for (const item of state.recurring) {
    if ((item.skippedMonths || []).includes(state.month)) continue;
    const exists = state.expenses.some(
      (expense) => expense.recurringId === item.id && expense.date.startsWith(state.month),
    );
    if (exists) continue;
    const day = clamp(Number(item.day) || 1, 1, 28);
    created.push({
      id: uid(),
      recurringId: item.id,
      expenseKind: "fixed",
      description: item.description,
      amount: item.amount,
      date: `${state.month}-${String(day).padStart(2, "0")}`,
      payer: item.payer,
      category: item.category,
      splitType: item.splitType,
      shareA: item.shareA,
      notes: "Generada automàticament",
    });
  }

  if (created.length) {
    await putMany("expenses", created);
    await loadState();
  }
  if (notify) {
    toast(created.length ? `${created.length} fixa(es) afegida(es)` : "Ja estaven generades");
    render();
  }
}

async function settleBalance() {
  const balance = calculateBalance();
  if (Math.abs(balance) < 0.01) return;
  const from = balance > 0 ? 1 : 0;
  if (
    !confirm(
      `Confirmes que ${state.settings.partners[from]} ha pagat ${money(Math.abs(balance))} a ${state.settings.partners[from === 0 ? 1 : 0]}?`,
    )
  ) {
    return;
  }
  await putOne("settlements", {
    id: uid(),
    from,
    to: from === 0 ? 1 : 0,
    amount: round2(Math.abs(balance)),
    date: today(),
    note: "Liquidacio exacta del balanç",
  });
  await loadState();
  toast("Balanç liquidat");
  render();
}

function openExpenseDialog(id) {
  state.editingExpenseId = id || null;
  buildExpenseForm(els.modalExpenseFields, { date: today() });
  els.dialogTitle.textContent = id ? "Editar despesa" : "Nova despesa";

  if (id) {
    const expense = state.expenses.find((item) => item.id === id);
    if (!canAccessExpense(expense)) {
      toast("No pots veure aquesta despesa");
      return;
    }
    if (expense) {
      fillExpenseForm(els.modalExpenseFields, expense);
      // Keep personal expenses of the current user locked to personal.
      if (isPersonalExpense(expense)) applyLedgerToExpenseForm(els.modalExpenseFields);
      else revealSplitOptionsForEdit(els.modalExpenseFields, expense);
    }
  }

  els.expenseDialog.showModal();
}

function closeExpenseDialog() {
  if (els.expenseDialog.open) els.expenseDialog.close();
  state.editingExpenseId = null;
}

function fillExpenseForm(root, expense) {
  root.querySelector('[name="id"]').value = expense.id;
  root.querySelector('[name="description"]').value = expense.description;
  root.querySelector('[name="amount"]').value = expense.amount;
  root.querySelector('[name="date"]').value = expense.date;
  root.querySelector('[name="payer"]').value = expense.payer;
  root.querySelector('[name="category"]').value = expense.category;
  root.querySelector(`[name="expenseKind"][value="${expense.expenseKind || (expense.recurringId ? "fixed" : "oneoff")}"]`).checked = true;
  const splitOption = root.querySelector(`[name="splitType"][value="${expense.splitType}"]`);
  (splitOption || root.querySelector('[name="splitType"][value="equal"]')).checked = true;
  root.querySelector('[name="shareA"]').value = expense.shareA || 50;
  root.querySelector('[name="notes"]').value = expense.notes || "";
  bindSplitPicker(root);
  root.querySelector("[data-share-field]").hidden = expense.splitType !== "custom";
}

async function saveTheme() {
  const theme = state.settings.theme === "dark" ? "light" : "dark";
  await putOne("settings", { ...state.settings, id: "main", theme });
  await loadState();
  applyTheme();
  render();
}

function applyTheme() {
  const dark = state.settings.theme === "dark";
  document.documentElement.dataset.theme = dark ? "dark" : "";
  const color = dark ? "#000000" : "#F2F2F7";
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => m.remove());
  const meta = document.createElement("meta");
  meta.name = "theme-color";
  meta.content = color;
  document.head.appendChild(meta);
  try { localStorage.setItem("mp2-theme-color", color); } catch {}
  document.documentElement.style.background = dark ? "#000000" : "#F2F2F7";
}

const VIEW_ORDER = ["overview", "movements", "settlements", "settings"];

function setView(view) {
  if (state.ledgerMode === "personal" && view === "settlements") {
    view = "overview";
  }
  if (!VIEWS[view]) view = "overview";
  if (view !== state.view) {
    const nextIndex = VIEW_ORDER.indexOf(view);
    const currentIndex = VIEW_ORDER.indexOf(state.view);
    state.navDirection = nextIndex >= currentIndex ? "forward" : "back";
    state.view = view;
  }
  render();
}

function changeTrendWindow(delta) {
  state.trendOffset = Math.max(0, state.trendOffset + delta);
  renderTrend();
}

async function changeMonth(delta) {
  const [year, month] = state.month.split("-").map(Number);
  state.month = monthKey(new Date(year, month - 1 + delta, 1));
  state.trendOffset = 0;
  await generateRecurringForMonth({ notify: false });
  render();
}

function exportCsv() {
  const rows = [
    ["tipus", "data", "concepte", "categoria", "import", "pagador", "repartiment", "notes"],
    ...state.expenses.map((expense) => [
      expense.recurringId || expense.expenseKind === "fixed" ? "fixa" : "puntual",
      expense.date,
      expense.description,
      expense.category,
      String(expense.amount).replace(".", ","),
      state.settings.partners[expense.payer],
      splitLabel(expense),
      expense.notes || "",
    ]),
    [],
    ["liquidacio", "data", "de", "a", "import", "nota"],
    ...state.settlements.map((settlement) => [
      "liquidacio",
      settlement.date,
      state.settings.partners[settlement.from],
      state.settings.partners[settlement.to],
      String(settlement.amount).replace(".", ","),
      settlement.note || "",
    ]),
  ];

  downloadText(`mitjapart-${today()}.csv`, rows.map(csvRow).join("\n"), "text/csv;charset=utf-8");
  toast("CSV exportat");
}


function restoreLedgerPreference() {
  try {
    const raw = localStorage.getItem(LEDGER_PREFERENCE_KEY);
    if (!raw) return;
    const saved = JSON.parse(raw);
    if (saved.ledgerMode === "shared" || saved.ledgerMode === "personal") {
      state.ledgerMode = saved.ledgerMode;
    }
  } catch {
    /* ignore invalid preference */
  }
}

function persistLedgerPreference() {
  localStorage.setItem(
    LEDGER_PREFERENCE_KEY,
    JSON.stringify({ ledgerMode: state.ledgerMode }),
  );
}

function setLedgerMode(mode) {
  if (mode !== "shared" && mode !== "personal") return;
  state.ledgerMode = mode;
  if (mode === "personal" && state.view === "settlements") {
    state.navDirection = "back";
    state.view = "overview";
  }
  if (mode === "shared") {
    state.filters.split = state.filters.split === "personal" ? "" : state.filters.split;
  }
  persistLedgerPreference();
  buildStaticForms();
  render();
}


function isPersonalExpense(expense) {
  return expense?.splitType === "personal";
}

function matchesCurrentLedger(expense) {
  // Never show another user's personal expenses in any mode.
  if (isPersonalExpense(expense)) {
    return state.ledgerMode === "personal" && Number(expense.payer) === state.personalOwner;
  }
  return state.ledgerMode === "shared";
}

function canAccessExpense(expense) {
  if (!expense) return false;
  if (!isPersonalExpense(expense)) return true;
  return Number(expense.payer) === state.personalOwner;
}

function visibleExpensesInMonth(month) {
  return expensesInMonth(month).filter(matchesCurrentLedger);
}

function renderLedgerControls() {
  const isPersonal = state.ledgerMode === "personal";
  const user = currentUser();
  const myName = user?.label || state.settings.partners[state.personalOwner] || "tu";

  els.app?.setAttribute("data-ledger", state.ledgerMode);
  if (user) els.app?.setAttribute("data-user", user.id);
  else els.app?.removeAttribute("data-user");

  document.querySelectorAll("button[data-ledger]").forEach((button) => {
    const active = button.dataset.ledger === state.ledgerMode;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-selected", active ? "true" : "false");
  });

  if (els.ledgerHint) {
    els.ledgerHint.textContent = isPersonal
      ? `Només les teves despeses particulars (${myName})`
      : "Despeses compartides de la parella";
  }

  if (els.sessionUserLabel) {
    els.sessionUserLabel.textContent = user
      ? `Has entrat com a ${displayUserName(user)}. Només veus el comú i les teves particulars.`
      : "No hi ha sessió activa.";
  }
}


function revealSplitOptionsForEdit(root, expense) {
  if (!root || !expense) return;
  root.querySelectorAll("[data-split-option]").forEach((option) => {
    // Never expose the particular option while editing shared expenses.
    option.hidden = option.dataset.splitOption === "personal";
  });
  const payerSelect = root.querySelector('[name="payer"]');
  if (payerSelect) payerSelect.disabled = false;
  const shareField = root.querySelector("[data-share-field]");
  if (shareField) shareField.hidden = expense.splitType !== "custom";
}

function applyLedgerToExpenseForm(root) {
  if (!root) return;
  const personalOption = root.querySelector('[data-split-option="personal"]');
  const equalOption = root.querySelector('[data-split-option="equal"]');
  const customOption = root.querySelector('[data-split-option="custom"]');
  const payerSelect = root.querySelector('[name="payer"]');

  if (state.ledgerMode === "personal") {
    if (equalOption) equalOption.hidden = true;
    if (customOption) customOption.hidden = true;
    if (personalOption) personalOption.hidden = false;
    const personalRadio = root.querySelector('[name="splitType"][value="personal"]');
    if (personalRadio) personalRadio.checked = true;
    if (payerSelect) {
      payerSelect.value = String(state.personalOwner);
      payerSelect.disabled = true;
    }
  } else {
    if (equalOption) equalOption.hidden = false;
    if (customOption) customOption.hidden = false;
    if (personalOption) personalOption.hidden = true;
    const equalRadio = root.querySelector('[name="splitType"][value="equal"]');
    const current = root.querySelector('[name="splitType"]:checked');
    if (current?.value === "personal" && equalRadio) equalRadio.checked = true;
    if (payerSelect) payerSelect.disabled = false;
  }

  const shareField = root.querySelector("[data-share-field]");
  if (shareField) {
    shareField.hidden = root.querySelector('[name="splitType"]:checked')?.value !== "custom";
  }
}

function expensesInMonth(month) {
  return state.expenses.filter((expense) => expense.date.startsWith(month)).sort(sortByDateDesc);
}

function filterExpenses(expenses) {
  return expenses.filter((expense) => {
    const text = `${expense.description} ${expense.notes || ""}`.toLowerCase();
    return (
      (!state.filters.search || text.includes(state.filters.search)) &&
      (!state.filters.category || expense.category === state.filters.category) &&
      (!state.filters.payer || String(expense.payer) === state.filters.payer) &&
      (!state.filters.type ||
        (state.filters.type === "fixed"
          ? expense.recurringId || expense.expenseKind === "fixed"
          : !expense.recurringId && expense.expenseKind !== "fixed")) &&
      (!state.filters.split || expense.splitType === state.filters.split)
    );
  });
}

function totalsByCategory(month, scope = "group") {
  const totals = new Map();
  visibleExpensesInMonth(month).forEach((expense) => {
    if (state.ledgerMode === "shared" && scope !== "group" && expense.payer !== Number(scope)) return;
    const row = totals.get(expense.category) || { category: expense.category, total: 0, payers: [0, 0] };
    row.total += expense.amount;
    row.payers[expense.payer] += expense.amount;
    totals.set(expense.category, row);
  });

  return [...totals.values()]
    .map((row) => ({
      category: row.category,
      total: round2(row.total),
      payers: row.payers.map(round2),
    }))
    .filter((row) => row.total > 0)
    .sort((a, b) => b.total - a.total);
}

function calculateBalance() {
  let balance = 0;
  state.expenses.forEach((expense) => {
    const [shareA, shareB] = splitAmount(expense);
    balance += expense.payer === 0 ? shareB : -shareA;
  });
  state.settlements.forEach((settlement) => {
    balance += settlement.from === 1 ? -settlement.amount : settlement.amount;
  });
  return round2(balance);
}

function splitAmount(expense) {
  if (expense.splitType === "personal") {
    return expense.payer === 0 ? [expense.amount, 0] : [0, expense.amount];
  }
  const shareA = expense.splitType === "custom" ? expense.shareA : 50;
  const amountA = round2(expense.amount * (shareA / 100));
  return [amountA, round2(expense.amount - amountA)];
}

function splitLabel(expense) {
  if (expense.splitType === "personal") return "Personal";
  if (expense.splitType === "custom") return `${expense.shareA}% / ${100 - expense.shareA}%`;
  return "50/50";
}

function resolveCategory(form) {
  const selected = form.get("category");
  if (selected !== "__new__") return { id: canonicalCategoryId(selected) };
  const created = canonicalCategoryId(String(form.get("newCategory") || "").trim());
  const icon = String(form.get("newCategoryIcon") || "").trim() || CATEGORY_ICON_OPTIONS[0];
  return {
    id: created || "Altres",
    icon,
    color: String(form.get("newCategoryColor") || "#176b5b"),
  };
}

async function ensureCategory(categoryInput) {
  const category = normalizeCategory(categoryInput);
  if (!category.id) return;

  const explicitIcon =
    typeof categoryInput === "object" && categoryInput.icon
      ? String(categoryInput.icon)
      : "";
  const explicitColor =
    typeof categoryInput === "object" && categoryInput.color
      ? String(categoryInput.color)
      : "";

  const index = state.categories.findIndex((item) => item.id === category.id);
  if (index >= 0) {
    const previous = state.categories[index];
    const next = {
      ...previous,
      icon: explicitIcon || previous.icon || category.icon,
      color: explicitColor || previous.color || category.color,
    };
    if (next.icon === previous.icon && next.color === previous.color) return;
    const categories = [...state.categories];
    categories[index] = next;
    await putOne("settings", { ...state.settings, id: "main", categories });
    state.settings.categories = categories;
    state.categories = categories;
    return;
  }

  const categories = [...state.categories, category].sort((a, b) => a.id.localeCompare(b.id, "ca"));
  await putOne("settings", {
    ...state.settings,
    id: "main",
    categories,
  });
  state.settings.categories = categories;
  state.categories = categories;
}

function getAllCategories(settings, expenses, recurring) {
  const map = new Map();
  CATEGORIES.forEach((category) => map.set(category.id, category));
  (settings?.categories || []).forEach((category) => {
    const normalized = normalizeCategory(category);
    if (!normalized.id) return;
    const existing = map.get(normalized.id);
    // Settings win for icons/colors so custom logos stick.
    map.set(
      normalized.id,
      existing
        ? {
            ...existing,
            ...normalized,
            icon: normalized.icon || existing.icon,
            color: normalized.color || existing.color,
          }
        : normalized,
    );
  });
  [...expenses, ...recurring].forEach((item) => {
    const id = canonicalCategoryId(item.category);
    if (!id || map.has(id)) return;
    map.set(id, normalizeCategory(id));
  });
  return [...map.values()].sort((a, b) => a.id.localeCompare(b.id, "ca"));
}

function normalizeCategory(category) {
  if (typeof category === "object" && category?.id) {
    const id = canonicalCategoryId(category.id) || "Altres";
    const existing = CATEGORIES.find((item) => item.id === id);
    return {
      id,
      icon: category.icon || existing?.icon || "📦",
      color: category.color || existing?.color || colorFromText(id),
    };
  }
  const id = canonicalCategoryId(String(category || "Altres")) || "Altres";
  const existing = CATEGORIES.find((item) => item.id === id);
  return existing || { id, icon: "📦", color: colorFromText(id) };
}

function categoryMeta(category) {
  const meta = state.categories.find((item) => item.id === category) || normalizeCategory(category);
  const color = displayCategoryColor(meta);
  return color === meta.color ? meta : { ...meta, color };
}

const DISPLAY_PALETTE = ["#2f8f67", "#5d55aa", "#c47d1a", "#c43d5a", "#1a7a9e", "#4a6fa5", "#b53a2c", "#8b6914", "#176b5b", "#6f6458", "#d4508f", "#3f9c3a", "#7a4fc9", "#e0662d", "#2b8fb3", "#9c6b3a"];
let colorCacheKey = null;
let colorCache = new Map();

// Display-only: give every category a distinct colour so legends and bars never clash.
function displayCategoryColor(meta) {
  const key = state.categories.map((c) => `${c.id}:${c.color}`).join("|");
  if (key !== colorCacheKey) {
    colorCacheKey = key;
    colorCache = new Map();
    const used = new Set();
    state.categories.forEach((c) => {
      let color = String(c.color || "").toLowerCase();
      if (!color || used.has(color)) color = DISPLAY_PALETTE.find((p) => !used.has(p.toLowerCase())) || color;
      used.add(String(color).toLowerCase());
      colorCache.set(c.id, color);
    });
  }
  return colorCache.get(meta.id) || meta.color;
}

function displayUserName(user) {
  const name = state.settings?.partners?.[user?.partnerIndex];
  return (name && String(name).trim()) || user?.label || "";
}

function topTrendCategories(months, scope = "group") {
  const totals = new Map();
  months.forEach((month) => {
    totalsByCategory(month, scope).forEach((row) => {
      totals.set(row.category, (totals.get(row.category) || 0) + row.total);
    });
  });
  return [...totals.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5)
    .map(([category]) => category);
}

function colorFromText(text) {
  const palette = ["#2f8f67", "#5d55aa", "#c47d1a", "#c43d5a", "#1a7a9e", "#8b6914"];
  const index = [...String(text)].reduce((total, char) => total + char.charCodeAt(0), 0) % palette.length;
  return palette[index];
}

function payerTrendColor(payer) {
  return payer === 0 ? "var(--primary)" : "var(--accent)";
}

function renderEmpty(container) {
  container.innerHTML = "";
  container.append(els.emptyTemplate.content.cloneNode(true));
}

function toast(message, type = "ok") {
  const element = document.createElement("div");
  element.className = `toast ${type}`;
  element.textContent = message;
  els.toastHost.append(element);
  setTimeout(() => element.remove(), 2600);
}

function downloadText(filename, content, type) {
  const blob = new Blob([content], { type });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}

function csvRow(values) {
  return values
    .map((value) => `"${String(value ?? "").replaceAll('"', '""')}"`)
    .join(",");
}

function money(value) {
  return new Intl.NumberFormat("ca-ES", { style: "currency", currency: "EUR" }).format(value || 0);
}

const countedValues = new Map();

function setCount(element, key, value, format = money) {
  if (!element) return;
  const next = Number(value) || 0;
  const hasPrevious = countedValues.has(key);
  const previous = hasPrevious ? countedValues.get(key) : 0;
  countedValues.set(key, next);
  if (element._countFrame) cancelAnimationFrame(element._countFrame);
  if ((hasPrevious && Math.abs(previous - next) < 0.005) || (!hasPrevious && next === 0)) {
    element.textContent = format(next);
    return;
  }
  const from = previous;
  const start = performance.now();
  const duration = 520;
  const tick = (now) => {
    const progress = Math.min(1, (now - start) / duration);
    const eased = 1 - (1 - progress) ** 3;
    element.textContent = format(progress === 1 ? next : from + (next - from) * eased);
    if (progress < 1) element._countFrame = requestAnimationFrame(tick);
  };
  element._countFrame = requestAnimationFrame(tick);
}

function animateProgress(container) {
  if (!container) return;
  container.querySelectorAll(".progress span, .progress .progress-stack").forEach((bar) => {
    const width = bar.style.width;
    bar.style.transition = "none";
    bar.style.width = "0%";
    requestAnimationFrame(() => {
      bar.style.transition = "";
      bar.style.width = width;
    });
  });
}

function initials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "•";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

function partnerAvatarColor(index) {
  return Number(index) === 0 ? "#007AFF" : "#5856D6";
}

function formatDate(value) {
  return new Intl.DateTimeFormat("ca-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${value}T12:00:00`));
}

function formatMonth(value) {
  const [year, month] = value.split("-").map(Number);
  const name = new Intl.DateTimeFormat("ca-ES", { month: "long" }).format(new Date(year, month - 1, 1));
  const label = `${name} de ${year}`;
  return label.charAt(0).toUpperCase() + label.slice(1);
}

function shortMonth(value) {
  const [year, month] = value.split("-").map(Number);
  return new Intl.DateTimeFormat("ca-ES", { month: "short" }).format(new Date(year, month - 1, 1));
}

function monthKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

function lastMonths(count) {
  const [year, month] = state.month.split("-").map(Number);
  return Array.from({ length: count }, (_, index) =>
    monthKey(new Date(year, month - 1 - (count - index - 1), 1)),
  );
}

function trendMonths(count) {
  const [year, month] = state.month.split("-").map(Number);
  return Array.from({ length: count }, (_, index) =>
    monthKey(new Date(year, month - 1 - state.trendOffset - (count - index - 1), 1)),
  );
}

function today() {
  return new Date().toISOString().slice(0, 10);
}

function uid() {
  return crypto.randomUUID();
}

function sum(values) {
  return values.reduce((total, value) => total + value, 0);
}

function round2(value) {
  return Math.round(value * 100) / 100;
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function sortByDateDesc(a, b) {
  return b.date.localeCompare(a.date);
}

function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
